//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import store from '@/vue/store';
import PageTop from './page-top.vue';
export default {
  store: store,
  components: {
    PageTop: PageTop
  },
  props: {
    sitename: null
  },
  computed: {
    blankAppName: function blankAppName() {
      return store.getters['app/blankAppName'];
    },
    isLocal: function isLocal() {
      return store.getters['app/isLocal'];
    }
  }
};